export default __webpack_public_path__ + "static/media/dashboard-illustration.5fd14575.svg";